import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../constants/text';
import ThumbsUp from '../../../../../components/SolvPatternLibrary/Icons/ThumbsUp';
import { connect } from 'react-redux';
import { INCREMENT_HELPFUL_COUNT } from '../../../../../sagas/solvRatings';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import { analyticsTrackEvent } from '../../../../../core/analytics';
import { CDP_REVIEWS_TOUCH_HELPFUL } from '../../../../../core/analytics/events';

const StyledButton = styled(Button)`
  font-family: ${fontFamily.book};
  height: 36px;
  font-size: ${fontSize.small};
  padding: 0px;
  margin-top: 20px;
  color: ${colors.squid};
  border: 1px solid ${colors.borderLine};
  margin-right: 12px;
  flex: 0 1 120px;
  text-transform: none;
  letter-spacing: -0.26px;
  line-height: 23px;
`;

const StyledThumbsUp = styled(ThumbsUp)`
  width: 15px;
`;

const HelpfulButtonContent = styled.div`
  width: 72%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HelpfulCount = styled.span`
  color: ${colors.lanaDelGrey};
`;

const Thanks = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.greenPeas};
  font-size: ${fontSize.small};
  margin-top: 20px;
  margin-right: 10px;
  cursor: default;
`;

const SpinnerContainer = styled.div`
  flex: 0 1 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  margin-top: 20px;
  color: ${colors.greenPeas};
`;

class HelpfulButton extends PureComponent {
  static propTypes = {
    helpfulCount: PropTypes.shape({
      updating: PropTypes.bool,
      updated: PropTypes.bool,
      error: PropTypes.string,
      value: PropTypes.number,
    }).isRequired,
    solvRatingId: PropTypes.string,
    incrementHelpfulCount: PropTypes.func,
  };

  handleClick = () => {
    const { solvRatingId, incrementHelpfulCount } = this.props;

    analyticsTrackEvent(CDP_REVIEWS_TOUCH_HELPFUL, { solvRatingId });
    incrementHelpfulCount(solvRatingId);
  };

  render = () => {
    const { helpfulCount } = this.props;

    if (helpfulCount.updating) {
      return (
        <SpinnerContainer>
          <CircularProgress size="20px" color="inherit" />
        </SpinnerContainer>
      );
    }

    if (helpfulCount.updated) {
      return <Thanks>Thanks for your feedback!</Thanks>;
    }

    return (
      <StyledButton onClick={this.handleClick}>
        <HelpfulButtonContent>
          <StyledThumbsUp />
          <span>Helpful</span>
          <HelpfulCount>({helpfulCount.value})</HelpfulCount>
        </HelpfulButtonContent>
      </StyledButton>
    );
  };
}

const mapDispatchToProps = dispatch => ({
  incrementHelpfulCount: solvRatingId => dispatch({ type: INCREMENT_HELPFUL_COUNT, solvRatingId }),
});

export default connect(
  null,
  mapDispatchToProps
)(HelpfulButton);
